import React from 'react';
import useThemeStore from '../store/useThemeStore';

const logoSizes = {
  sm: { img: 28 },
  md: { img: 36 },
  lg: { img: 120 },
  xl: { img: 160 },
};

export default function Logo({ size = 'md', showWordmark = true, centered = false }) {
  const s = logoSizes[size] || logoSizes.md;
  const { theme } = useThemeStore();

  // Centered large logo for home page — switches between dark/light version
  if (centered) {
    return (
      <img
        src={theme === 'light' ? '/logo-light.png' : '/logo-dark.png'}
        alt="findr"
        style={{ height: s.img, width: 'auto', objectFit: 'contain' }}
      />
    );
  }

  // Small icon version for headers/nav — uses the icon image
  return (
    <div className="flex items-center gap-2">
      <img
        src="/logo-icon.png"
        alt="findr"
        style={{ width: s.img, height: s.img, objectFit: 'contain', borderRadius: 10 }}
        onError={(e) => {
          // Fallback to gradient box if image not found
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
      {/* Fallback gradient box (hidden by default) */}
      <div
        className="bg-brand-gradient rounded-xl items-center justify-center flex-shrink-0"
        style={{ width: s.img, height: s.img, display: 'none' }}
      >
        <span style={{ color: '#fff', fontSize: s.img * 0.48, fontWeight: 800, fontFamily: 'Inter' }}>f</span>
      </div>
      {showWordmark && (
        <span style={{ fontSize: s.img * 0.45, fontWeight: 800, color: '#EBEBF5', letterSpacing: '-0.5px' }}>
          findr
        </span>
      )}
    </div>
  );
}
